import { render, staticRenderFns } from "./CoursesMain.vue?vue&type=template&id=73590172&scoped=true"
import script from "./CoursesMain.vue?vue&type=script&lang=js"
export * from "./CoursesMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73590172",
  null
  
)

export default component.exports